import { Component, type ErrorInfo, type ReactNode } from 'react'

interface Props {
  children?: ReactNode
}

interface State {
  hasError: boolean
  message: string
}

class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: '' }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, message: error?.message || '' }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('畫面發生錯誤:', error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-zinc-950 flex items-center justify-center px-4">
          <div className="max-w-sm w-full text-center">
            <h1 className="font-serif text-xl text-stone-50 mb-3">頁面暫時無法顯示</h1>
            <p className="text-sm text-stone-400 mb-6 leading-relaxed">
              發生未預期的錯誤，請重新整理後再試一次。
            </p>
            <button
              type="button"
              onClick={() => {
                if (typeof window !== 'undefined') {
                  window.location.reload()
                }
              }}
              className="w-full py-3 h-12 bg-stone-50 text-zinc-950 text-sm tracking-wide hover:bg-stone-200 active:scale-[0.98] transition-all rounded-sm"
            >
              重新整理
            </button>
          </div>
        </div>
      )
    }

    return this.props.children ?? null
  }
}

export default ErrorBoundary
